var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.$attrs.label,"rules":_vm.rules,"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var valid = ref.valid;
return [_c('DateField',_vm._g(_vm._b({attrs:{"errors":errors,"valid":valid,"rules":_vm.rules,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'DateField',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }